import { formatDistanceToNow } from 'date-fns';

export const formatBehandlesAvItem = (item) =>
  `${item.navn || 'ukjent'}, ${formatDistanceToNow(new Date(item.time))}`;
